import { Pipe, PipeTransform } from '@angular/core';
import { AmministrazioneTrasparente, CastSpettacolo } from './interface';

@Pipe({
    name: 'categoriaAmministrazioneTrasparente',
    pure: false
})
export class categoriaAmministrazioneTrasparentePipe implements PipeTransform {
    transform(files: AmministrazioneTrasparente[], query: string): any {
        return files.filter((file: AmministrazioneTrasparente) => file.categoria?.toLowerCase().indexOf(query.toLowerCase()) >= 0)
    }
}

@Pipe({
    name: 'prezziSpettacolo',
    pure: false
})
export class prezziSpettacoloPipe implements PipeTransform {
    transform(prezzi: { header: string, value: string }[], query: string): any {
        return prezzi.filter((prezzo: { header: string, value: string }) => prezzo.value?.toLowerCase().indexOf(query.toLowerCase()) >= 0)
    }
}

@Pipe({
    name: 'ruoloCastSpettacolo',
    pure: false
})
export class ruoloCastSpettacoloPipe implements PipeTransform {
    transform(filtered_casts: string[], casts: CastSpettacolo[], query: string): any {
        return casts.filter(cast => (cast?.ruolo || '')?.toLowerCase().indexOf(query.toLowerCase()) >= 0)
    }
}